import React, { useState } from "react";

import { gql, useMutation } from "@apollo/client";

import { Formik, Field, Form } from "formik";
import LoadingOverlay from "react-loading-overlay";
import "../../../../forms.css";
import "./ChangePasswordForm.css";
import LinkButton from "../../../LinkButton";

const CHANGE_PASSWORD = gql`
  mutation ChangePassword(
    $currentPassword: String!
    $newPassword: String!
    $newPasswordConfirm: String!
  ) {
    changePassword(
      currentPassword: $currentPassword
      newPassword: $newPassword
      newPasswordConfirm: $newPasswordConfirm
    ) {
      success
    }
  }
`;

export default function ChangePasswordForm(props) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(undefined);

  const [changePassword] = useMutation(CHANGE_PASSWORD);

  if (success) {
    return (
      <div className="change-password-form">
        Password changed successfully. <br />
        <br />
        <br />
        <LinkButton onClick={(e) => props.closeOverlay(e)}>Close</LinkButton>
      </div>
    );
  }

  return (
    <div className="change-password-form">
      <h1>Change Password</h1>
      <Formik
        initialValues={{
          currentPassword: "",
          newPassword: "",
          newPasswordConfirm: "",
        }}
        onSubmit={async (values) => {
          setLoading(true);

          changePassword({
            variables: {
              currentPassword: values.currentPassword,
              newPassword: values.newPassword,
              newPasswordConfirm: values.newPasswordConfirm,
            },
          })
            .then(() => {
              setLoading(false);
              setSuccess(true);
            })
            .catch((error) => {
              setErrorMessage(error.graphQLErrors[0].message);
              setLoading(false);
            });
        }}
      >
        <LoadingOverlay spinner active={loading}>
          <Form>
            <label htmlFor="currentPassword" className="form-label">
              Current Password
            </label>
            <Field
              id="currentPassword"
              name="currentPassword"
              type="password"
              className="form-input"
            />

            <label htmlFor="newPassword" className="form-label">
              New Password
            </label>
            <Field
              id="newPassword"
              name="newPassword"
              type="password"
              className="form-input"
            />

            <label htmlFor="newPasswordConfirm" className="form-label">
              Confirm New Password
            </label>
            <Field
              id="newPasswordConfirm"
              name="newPasswordConfirm"
              type="password"
              className="form-input"
            />

            {errorMessage !== undefined ? <p>{errorMessage}</p> : null}

            <button type="submit" className="form-submit">
              Submit
            </button>
            <LinkButton onClick={(e) => props.closeOverlay(e)}>
              Cancel
            </LinkButton>
          </Form>
        </LoadingOverlay>
      </Formik>
    </div>
  );
}
